import { render, staticRenderFns } from "./DeleteSchoolModal.vue?vue&type=template&id=1dd6ebf6&"
import script from "./DeleteSchoolModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSchoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports